// extracted by mini-css-extract-plugin
export default {"tabList":"Actions_tabList__rd9pM","tab":"Actions_tab__fEpko","tabSelected":"Actions_tabSelected__FBKAE"};